
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: '', align: 'center', value: 'custom', width: '10' },
  { text: 'Source Onboarding', value: 'source_onboarding_name'},
  { text: 'Inputer ID - Name', value: 'request_by' },
  { text: 'Nama Merchant', value: 'merchant_name' },
  { text: 'Reference No', value: 'reference_number' },
  { text: 'MID', value: 'mid' },
  { text: 'Jenis Pengajuan', value: 'task_type', align: 'center' },
  { text: 'Jenis QR', value: 'qr_type', align: 'center', textAlign: 'text-center' },
  { text: 'Tanggal Pengajuan', value: 'created_at'},
  { text: 'Last Update', value: 'updated_at',},
  { text: 'Status', value: 'status', align: 'center', textAlign: 'text-center' },
]);

export const dataMaxSelectedApproval = 50;

export const search = {
  mid: '',
  reference_number: '',
};

